/**
 * The `report` namespace. Its shape is the contract for every locale.
 * Interpolation: `{{deadline}}`, `{{name}}`, `{{time}}`, `{{date}}`, `{{count}}`.
 */
export const enUs = {
  nav: {
    report: 'My report',
    history: 'History',
    team: 'Team',
  },
  report: {
    title: 'Weekly report',
    titleOf: 'Weekly report of {{name}}',
    previousWeek: 'Previous week',
    nextWeek: 'Next week',
    thisWeek: 'This week',
    pickWeek: 'Week',
    planThisWeek: 'Plan for this week',
    days: 'Daily report',
    planNextWeek: 'Plan for next week',
    editableUntil: 'Editable until {{deadline}}',
    lockedSince: 'Locked since {{deadline}}',
    confirmedBy: 'Confirmed by {{name}} ({{time}})',
    notWritten: 'Not written yet.',
    inherited: "Carried over from last week's plan for next week. Edit it and save.",
    save: 'Save',
    saved: 'Saved.',
    unsaved: 'Unsaved changes',
    draftFound: 'Unsaved changes from {{time}} were kept on this device.',
    restoreDraft: 'Restore',
    discardDraft: 'Discard',
    conflict:
      'This report was changed elsewhere. Reload it to continue; your text is kept as a draft.',
    reload: 'Reload',
    leaveTitle: 'Leave without saving?',
    leave: 'Leave',
    stay: 'Stay',
    workTimesUnavailable: 'Work times are unavailable right now.',
    modified: 'Modified',
    history: 'History',
  },
  editor: {
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    strike: 'Strikethrough',
    bulletList: 'Bulleted list',
    orderedList: 'Numbered list',
    link: 'Link',
    linkAddress: 'Link address (https://… or mailto:…)',
    invalidLink: 'Enter an address starting with https://, http:// or mailto:.',
    removeLink: 'Remove link',
    clearFormatting: 'Clear formatting',
    undo: 'Undo',
    redo: 'Redo',
  },
  revisions: {
    title: 'Change history',
    empty: 'No changes yet.',
    inherited: 'Carried over',
    before: 'Before',
    after: 'After',
    planThisWeek: 'Plan for this week',
    planNextWeek: 'Plan for next week',
    day: 'Daily report {{date}}',
  },
  history: {
    title: 'History',
    week: 'Week',
    status: 'Status',
    deadline: 'Deadline',
    confirmedAt: 'Confirmed',
    empty: 'No reports yet.',
  },
  team: {
    group: 'Group',
    allGroups: 'All groups',
    title: 'Team reports',
    member: 'Member',
    weeks: 'Weeks',
    unconfirmedOnly: 'Unconfirmed only',
    missing: 'Not written',
    locked: 'Past the deadline',
    empty: 'No members.',
  },
  audit: {
    title: 'Audit log',
    time: 'Time',
    actor: 'By',
    action: 'Action',
    target: 'Target',
    system: 'System',
    actions: {
      ReportConfirmed: 'Report confirmed',
      ReportUnconfirmed: 'Confirmation withdrawn',
      LocalAdminGranted: 'Administrator added',
      LocalAdminRevoked: 'Administrator removed',
    },
  },
};

export type ReportResources = typeof enUs;
